exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ShippingInfo{margin:0 auto;width:288px}.ShippingInfo-header{font-size:24px;font-weight:500;margin-bottom:16px}.ShippingInfo-header img{width:100%}.ShippingInfo-subHeader{font-size:14px;font-weight:normal;margin-top:4px;margin-bottom:16px}.ShippingInfo-form-error{color:var(--text-negative)}.ShippingInfo .TextField{margin-bottom:16px}", ""]);

// exports
